import { createGlobalStyle } from 'styled-components'

const GlobalPrintStyles = createGlobalStyle`
	// page print settings
	@page {
	  size: A4;
	  margin: 20mm 15mm;
	}

	// global print style classes
	@media print {
		.print-border {
			border: 1px solid ${ (props) => props.theme.colors['hintergrund-prio3'] };
			margin-bottom: 20px;
			page-break-before: auto;
		}

		.container-fluid {
			min-width: auto;
			width: 1000px;
		}

		// use this class if firefox cut the flex-styled content
		.print-as-block {
			display: block !important;
		}

    .print-hide {
      display: none;
    }

    .print-flex-full-width {
      max-width: 100%;
      flex-basis: 100%;
    }

    div[data-cy="bookmark-toggle"] {
      display: none;
    }

    // set header-spacer to zero in print
    .header-spacer {
      margin-top: 0;
    }
	}

	// hide scroll to prevent double scrollbar
	// e.g. if overlay is visible and overlay content is scrollable
	html.prevent-scroll {
		overflow: hidden;
		height: 100%;
	}

	.app-main {
		margin-top: 20px;

		@media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
			margin-top: 30px;
		}
    }

    #bookmark-overlay {
    	.bookmark-btn-container {
    		text-align: right;
    	}

    	.bookmark-overlay-btn-save {
    		margin-top: 10px;
    	}

    	.bookmark-overlay-btn-cancel {
    		margin: 10px 0 0;
			@media ${ (props) => props.theme.breakpoints.devices.min.sm } {
				margin-right: 20px;
			}
    	}
    }

    .tooltip-location-btn {
		margin-top: 15px;
		display: block;
	}
`

export default GlobalPrintStyles
